<div class="font-bold mb-3" i18n>Please select the services you want to enable in USIM.</div>
<div class="mb-3">
  <table cellspacing="0" cellpadding="0">
    <tr valign="top">
      <td>
        <div class="ml-2 mr-3">
          <img src="assets/images/icon-guidance.png" width="24px" height="24px" />
        </div>
      </td>
      <td>
        <div i18n>
          Guidance: The services are indicated in an elementary filed called EF_UST (USIM Service Table). It covers a broad range of
          services or features your network requires and/or target devices needs to support. The examples include, but are not limited to,
          Short Message Service Parameters (SMSP), Group Identifier Level 1, GSM Access, OPLMN w/ AcT, and SUCI calculation by the USIM.
        </div>
      </td>
    </tr>
  </table>
</div>
<div class="ml-6 mr-6 pt-3">
  <div style="width: 900px">
    <table width="100%" cellspacing="0" cellpadding="5" border="1">
      <tr style="background: var(--rs-table-header-bg)">
        <th style="width: 6rem; text-align: center"><span class="font-bold" i18n>Entry #</span></th>
        <th style="text-align: center">
          <span class="font-bold" i18n>Service</span>
        </th>
        <th style="width: 6rem; text-align: center">
          <span class="font-bold" i18n>Support</span>
        </th>
      </tr>
      <tr *ngFor="let row of usimToService | keyvalue: preserveOrder; let i = index" style="text-align: center">
        <td>{{ i + 1 }}</td>
        <td i18n>{{ row.value.title }}</td>
        <td>
          <p-checkbox
            [styleClass]="'checkbox-readonly'"
            [binary]="true"
            [readonly]="true"
            [(ngModel)]="profileValues.usimServiceTable[row.key]"
            [pTooltip]="row.value.tooltip"
            i18n-pTooltip
            tooltipPosition="right"
            [showDelay]="250"
          />
        </td>
      </tr>
    </table>
  </div>
</div>
